import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.tz.setDefault('Asia/Tokyo')
dayjs.locale(ja)

export const getAreaPrefectureName = (key) => {
  if (areaToPrefTable.some((item) => item.key === key)) {
    return areaToPrefTable.find((item) => item.key === key).name
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === key)
    if (pref) {
      return pref.name
    }
  }
  return null
}

const HOKKAIDO_REGIONS = new Set(['douou', 'doutou', 'dounan', 'douhoku'])

export const getThumbnailPath = (prefKey) => {
  if (prefKey === 'okinawa') {
    return '/okinawa/'
  }
  if (HOKKAIDO_REGIONS.has(prefKey)) {
    return '/hokkaido/'
  }
  for (const area of areaToPrefTable) {
    for (const pref of area.pref_list) {
      if (pref.key === prefKey) {
        return `/${area.key}/${prefKey}/`
      }
    }
  }
  return '/'
}

export const formattedWindList = (windData, palette) => {
  const runtimeConfig = useRuntimeConfig()
  const isDev = !!runtimeConfig.public.devDomains
  const start = dayjs().startOf('hour')
  const end = dayjs().startOf('hour').add(72, 'hour')

  if (isDev) {
    const list = Object.entries(windData)
      .filter(([key]) => {
        const t = dayjs(key)
        return t.isSameOrAfter(start) && t.isSameOrBefore(end)
      })
      .map(([key, value]) => {
        const u = value['1']
        const v = value['2']
        const spd = Math.hypot(u, v)
        const spdRounded = Math.round(spd * 10) / 10
        let dir = (-Math.atan2(v, u) * 180 / Math.PI - 90)
        if (dir < 0) dir += 360
        if (dir >= 360) dir -= 360
        const timeValue = dayjs(key).tz('Asia/Tokyo').format('H')
        const result = {
          time: timeValue,
          spd: spdRounded.toFixed(1),
          color: setWindColor(spdRounded, palette),
          dir: (Math.floor(dir / 22.5 + 15.5) % 16) + 1
        }
        if (timeValue === '0') {
          result.date = dayjs(key).tz('Asia/Tokyo').format('D日')
        }
        return result
      })
    return list
  } else {
    if (windData.auth === 'OK') {
      const list = windData.wind_list
        .filter((item) => {
          const t = dayjs.unix(item.tm)
          return t.isSameOrAfter(start) && t.isSameOrBefore(end)
        })
        .map((item) => {
          const timeValue = dayjs.unix(item.tm).tz('Asia/Tokyo').format('H')
          const result = {
            time: timeValue,
            spd: item.spd.toFixed(1),
            color: setWindColor(item.spd, palette),
            dir: item.dir
          }
          if (timeValue === '0') {
            result.date = dayjs.unix(item.tm).tz('Asia/Tokyo').format('D日')
          }
          return result
        })
      return list
    } else {
      return null
    }
  }
}

export const getDefaultPosition = (key) => {
  if (key === 'KANTO') {
    return areaToLatLonTable['KANTO2']
  }
  return areaToLatLonTable[key]
}

export const getFullPrefectureName = (prefKey, type = null) => {
  const specialPrefectures = {
    東京: '都',
    大阪: '府',
    京都: '府'
  }
  if (areaToPrefTable.some((item) => item.key === prefKey)) {
    return `${areaToPrefTable.find((item) => item.key === prefKey).name}県`
  }
  for (const area of areaToPrefTable) {
    const pref = area.pref_list.find((pref) => pref.key === prefKey)
    if (pref) {
      if (pref.name in specialPrefectures) {
        return `${pref.name}${specialPrefectures[pref.name]}`
      }
      if (HOKKAIDO_REGIONS.has(pref.key)) {
        if (type === 'area') {
          return '北海道'
        }
        return pref.name
      }
      return `${pref.name}県`
    }
  }
  return null
}

export const setWindColor = (windSpd, palette) => {
  if (!palette || palette.length === 0) return 'rgba(0,0,0,0)'
  let color = palette[0]
  for (const element of palette) {
    if (windSpd >= element[0]) {
      color = element
    } else {
      break
    }
  }
  // RGBA形式で返す
  const [, r, g, b, a] = color
  return `rgba(${r},${g},${b},${a / 255})`
}

export const createRadarLink = (weather, currentPath) => {
  const params = currentPath.split('/').filter(Boolean)
  switch (params.length) {
    case 1: {
      return `/onebox/${weather}/${params[0]}/`
    }
    case 2: {
      if (params[0] === 'okinawa') {
        return `/onebox/${weather}/${params[0]}/${params[1]}/`
      }
      return `/onebox/${weather}/${params[1]}/`
    }
    case 3: {
      return `/onebox/${weather}/${params[1]}/${params[2]}/`
    }
    default: {
      return `/onebox/${weather}/`
    }
  }
}

export const generateWxLink = (areaEn, prefEn, citycode) => {
  const baseUrl = 'https://weathernews.jp'
  if (citycode) {
    return `${baseUrl}/onebox/tenki/${prefEn}/${citycode}/?fm=radar_menu`
  } else if (prefEn) {
    return `${baseUrl}/onebox/tenki/${prefEn}/?fm=radar_menu`
  } else if (areaEn) {
    return areaEn === 'japan' ? `${baseUrl}?fm=radar_menu` : `${baseUrl}/onebox/tenki/${areaEn}/?fm=radar_menu`
  } else {
    return `${baseUrl}?fm=radar_menu`
  }
}
